/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TabBarQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly " $refType": "TabBarQueryLocal";
};
export type TabBarQueryLocal$data = TabBarQueryLocal;
export type TabBarQueryLocal$key = {
    readonly " $data"?: TabBarQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '61b25b3794bba596651ff9a85a5c3445';
export default node;
